import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'my-courses-conflicts-modal',
    templateUrl: './my-courses-conflicts.component.html',
    styleUrls: ['./my-courses-conflicts.component.scss'],
    standalone: false
})
export class MyCoursesConflictsModalComponent implements OnInit {
    @Input() enrollment: any;
    @Input() instructors: any[];
    @Input() moreConflicts: boolean = false;

    constructor(
        public activeModal: NgbActiveModal
    ) { }

    ngOnInit() { }

   
}
